import React from "react"
import { DropdownEllipsisMenu } from "../../common/dropdown"
import { useSelector } from "react-redux"
import { ProposalSelector } from "../../state/proposal/selectors"
import {DropdownItemPrint} from "../../common/dropdown/DropdownItemPrint"
import {DropdownItemDelete} from "../../common/dropdown/DropdownItemDelete"
import {StockDocumentSelector} from "../../state/inventory/stockdocument/selectors"
import {STOCK_DOCUMENT_STATUS} from "../../common/types/inventory"

export const StockDocumentFooterDropdownMenu = () => {
    const printUrl = useSelector(ProposalSelector.getPrintUrl)
    const isPartiallyReceived = useSelector(StockDocumentSelector.isPartiallyReceived)
    const documentStatus = useSelector(StockDocumentSelector.getDocumentStatus)

    const items = [
        DropdownItemPrint(printUrl),
    ]
    if (!isPartiallyReceived && documentStatus !== STOCK_DOCUMENT_STATUS.COMPLETED) {
        items.push(DropdownItemDelete())
    }
    return <DropdownEllipsisMenu
        items={items}
    />
}


// WEBPACK FOOTER //
// ./src/inventory/components/StockDocumentFooterDropdownMenu.tsx